//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { format } from 'date-fns'

export default {
  props: {
    inspectionData: {
      type: Object,
      default: null,
    },
    visibleSync: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      format,
      imageModalVisible: false,
      selectedImage: null,
    }
  },
  computed: {
    inspection() {
      const medias = []
      this.inspectionData?.medias?.forEach((m) => {
        if (m.content) {
          const fileNameSplit = m.description.split('.')
          const extension = fileNameSplit[fileNameSplit.length - 1]
          m.content = `data:image/${extension};base64,${m.content}`
        }
        const detailIndex = this.inspectionData.details.details.findIndex(
          (d) => {
            return d.value === m.inspectionMediaGuid
          }
        )
        if (detailIndex >= 0) {
          m.description = this.inspectionData.details.details[detailIndex].name
          const [detail] =
            // eslint-disable-next-line vue/no-mutating-props
            this.inspectionData.details.details.splice(detailIndex, 1)

          console.log(detail)
        }
        medias.push(m)
      })

      const details = this.inspectionData.details.details
      return { details, medias }
    },
    gridRows() {
      if (!this.inspection.details) return []

      const details = this.inspection.details
      const rows = []

      // Create rows with 2 columns each
      for (let i = 0; i < details.length; i += 2) {
        const row = [details[i]]
        if (i + 1 < details.length) {
          row.push(details[i + 1])
        }
        rows.push(row)
      }

      return rows
    },
    mediaGridRows() {
      const medias = this.inspection.medias
      const rows = []

      // Create rows with 2 columns each
      for (let i = 0; i < medias.length; i += 2) {
        const row = [medias[i]]
        if (i + 1 < medias.length) {
          row.push(medias[i + 1])
        }
        rows.push(row)
      }

      return rows
    },
  },
  methods: {
    closeDialog() {
      this.$nuxt.$emit('closeInspectionDialog')
    },
    openImageModal(media) {
      this.selectedImage = media
      this.imageModalVisible = true
    },
  },
}
